var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConcierge(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.27782 14.5534H18.7222C18.4662 11.0652 15.5532 8.31289 12 8.31289C8.44676 8.31289 5.53383 11.0652 5.27782 14.5534ZM4.25953 15.0534C4.25953 10.7797 7.7263 7.31289 12 7.31289C16.2737 7.31289 19.7405 10.7797 19.7405 15.0534V15.5534H4.25953V15.0534Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.40261 17.5233C4.17906 17.5233 3.995 17.7073 3.995 17.9309C3.995 18.1544 4.17906 18.3385 4.40261 18.3385H19.5974C19.8209 18.3385 20.005 18.1544 20.005 17.9309C20.005 17.7073 19.8209 17.5233 19.5974 17.5233H4.40261ZM2.995 17.9309C2.995 17.155 3.62678 16.5233 4.40261 16.5233H19.5974C20.3732 16.5233 21.005 17.155 21.005 17.9309C21.005 18.7067 20.3732 19.3385 19.5974 19.3385H4.40261C3.62677 19.3385 2.995 18.7067 2.995 17.9309Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 6.81351V7.8129H11.5V6.81351H12.5Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.66149C11.8199 5.66149 11.674 5.80745 11.674 5.98751C11.674 6.16757 11.8199 6.31353 12 6.31353C12.18 6.31353 12.326 6.16757 12.326 5.98751C12.326 5.80745 12.18 5.66149 12 5.66149ZM10.674 5.98751C10.674 5.25517 11.2676 4.66149 12 4.66149C12.7323 4.66149 13.326 5.25516 13.326 5.98751C13.326 6.71985 12.7323 7.31353 12 7.31353C11.2676 7.31353 10.674 6.71985 10.674 5.98751Z",
    fill: "var(--icon-color,var(--color-text,#363636))"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConcierge);
export default __webpack_public_path__ + "static/media/concierge.6a4fd81bccac554bad1ae2874cd5b841.svg";
export { ForwardRef as ReactComponent };